program PlayStreamWebProject;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  PlayerMain in 'PlayerMain.pas'{*.html},
  PlayListBuilder in 'PlayListBuilder.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TPlayerForm, PlayerForm);
  Application.Run;
end.
